module.exports = __webpack_public_path__ + "static/media/chrpe_fw1.71cca492.jpg";